/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Broker,
    BrokerFromJSON,
    BrokerFromJSONTyped,
    BrokerToJSON,
    ConsumerGroupState,
    ConsumerGroupStateFromJSON,
    ConsumerGroupStateFromJSONTyped,
    ConsumerGroupStateToJSON,
} from './';

/**
 * 
 * @export
 * @interface ConsumerGroup
 */
export interface ConsumerGroup {
    /**
     * 
     * @type {string}
     * @memberof ConsumerGroup
     */
    groupId: string;
    /**
     * 
     * @type {number}
     * @memberof ConsumerGroup
     */
    members?: number;
    /**
     * 
     * @type {number}
     * @memberof ConsumerGroup
     */
    topics?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConsumerGroup
     */
    simple?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConsumerGroup
     */
    partitionAssignor?: string;
    /**
     * 
     * @type {ConsumerGroupState}
     * @memberof ConsumerGroup
     */
    state?: ConsumerGroupState;
    /**
     * 
     * @type {Broker}
     * @memberof ConsumerGroup
     */
    coordinator?: Broker;
    /**
     * 
     * @type {number}
     * @memberof ConsumerGroup
     */
    messagesBehind?: number;
}

export function ConsumerGroupFromJSON(json: any): ConsumerGroup {
    return ConsumerGroupFromJSONTyped(json, false);
}

export function ConsumerGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumerGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groupId': json['groupId'],
        'members': !exists(json, 'members') ? undefined : json['members'],
        'topics': !exists(json, 'topics') ? undefined : json['topics'],
        'simple': !exists(json, 'simple') ? undefined : json['simple'],
        'partitionAssignor': !exists(json, 'partitionAssignor') ? undefined : json['partitionAssignor'],
        'state': !exists(json, 'state') ? undefined : ConsumerGroupStateFromJSON(json['state']),
        'coordinator': !exists(json, 'coordinator') ? undefined : BrokerFromJSON(json['coordinator']),
        'messagesBehind': !exists(json, 'messagesBehind') ? undefined : json['messagesBehind'],
    };
}

export function ConsumerGroupToJSON(value?: ConsumerGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groupId': value.groupId,
        'members': value.members,
        'topics': value.topics,
        'simple': value.simple,
        'partitionAssignor': value.partitionAssignor,
        'state': ConsumerGroupStateToJSON(value.state),
        'coordinator': BrokerToJSON(value.coordinator),
        'messagesBehind': value.messagesBehind,
    };
}

